var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph:x-logo-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8557 13.8808C13.8127 13.9592 13.7494 14.0246 13.6724 14.0702C13.5955 14.1159 13.5077 14.14 13.4182 14.1401H10.4182C10.3341 14.1401 10.2513 14.1188 10.1775 14.0783C10.1038 14.0378 10.0415 13.9793 9.99634 13.9083L7.46571 9.93139L3.78821 13.9764C3.69856 14.0727 3.57457 14.1298 3.44312 14.1353C3.31166 14.1408 3.18334 14.0942 3.08597 14.0057C2.9886 13.9172 2.93003 13.7939 2.92297 13.6626C2.9159 13.5312 2.9609 13.4023 3.04821 13.3039L6.90884 9.05389L2.99634 2.90889C2.94815 2.83329 2.92118 2.74613 2.91824 2.65652C2.9153 2.56692 2.93651 2.47818 2.97964 2.39959C3.02277 2.321 3.08623 2.25544 3.16339 2.2098C3.24055 2.16415 3.32856 2.14009 3.41821 2.14014H6.41821C6.50236 2.14016 6.58515 2.16143 6.65889 2.20196C6.73264 2.24249 6.79496 2.30098 6.84009 2.37201L9.37071 6.34889L13.0482 2.30389C13.1379 2.20759 13.2619 2.1505 13.3933 2.14501C13.5248 2.13952 13.6531 2.18606 13.7505 2.27455C13.8478 2.36303 13.9064 2.48633 13.9135 2.61771C13.9205 2.74909 13.8755 2.87796 13.7882 2.97639L9.92759 7.22326L13.8401 13.372C13.888 13.4476 13.9147 13.5348 13.9175 13.6242C13.9202 13.7137 13.8989 13.8023 13.8557 13.8808Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.090bf0692f2440272a9265bd2a0e7e68.svg";
export { ForwardRef as ReactComponent };